import { createEffect, createSignal, on } from "solid-js";

import { cookieStorage } from "@solid-primitives/storage";

enum GlobalCacheOptions {
  GlobalCache = "global_cache",
}

export const useGlobalCacheCookie = () => {
  const [cookies, setCookies] = createSignal(
    JSON.parse(cookieStorage.getItem(GlobalCacheOptions.GlobalCache) ?? "{}"),
  );

  createEffect(
    on(cookies, (value) => {
      if (Object.keys(value).length === 0) {
        cookieStorage.removeItem(GlobalCacheOptions.GlobalCache);
      } else {
        cookieStorage.setItem(
          GlobalCacheOptions.GlobalCache,
          JSON.stringify(value),
        );
      }
    }),
  );

  const get = (key: string) => cookies()[key];

  const set = (key: string, value: string | number) =>
    setCookies((prev) => ({ ...prev, [key]: value }));

  const remove = (key: string) => {
    setCookies((prev) => {
      const newCookies = { ...prev };
      delete newCookies[key];
      return newCookies;
    });
  };

  return {
    cookies,
    get,
    set,
    remove,
  };
};
